<template>
  <div>
    <div class="relative aspect-video w-full overflow-hidden text-white">
      <div
        class="absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center"
        :style="backgroundOverlay"
      >
        <IconPlay
          data-testid="video-play-button"
          class="h-10 w-10 cursor-pointer lg:h-16 lg:w-16"
          @click="handlerPlay"
        />
      </div>
      <div class="relative z-0 h-full w-full">
        <img
          v-if="videoCover"
          :src="videoCover"
          class="flex h-full max-h-full w-full object-cover"
          alt="Video Cover Vimeo"
          data-testid="video-intro-card-image"
        />
      </div>
    </div>
    <VideoModal
      v-if="vimeoVideo && $modal.getModal('videoIntro')"
      :vimeo-source="vimeoSource"
      :video-ratio="videoRatio"
    />
  </div>
</template>

<script setup lang="ts">
import VideoModal from '~/components/video/VideoModal.vue'
import IconPlay from '~/assets/icons/icon-play.svg'

/*-------------------------------------
  Props & Refs
-------------------------------------*/
const props = defineProps<{
  vimeoId: number | string
}>()

const { $modal } = useNuxtApp()
const {
  getVimeoData,
  vimeoVideo,
  vimeoSource,
  videoRatio,
  videoCover,
  backgroundOverlay,
  handlerPlay,
} = useGetVimeoData()

/*-------------------------------------
  Lifecycle
-------------------------------------*/
onMounted(async () => {
  await getVimeoData(props.vimeoId)
})
</script>
